import React from 'react';

const IndustriesSection: React.FC = () => {
  const industries = [
    { name: 'Retail & E-Commerce', icon: require('../assets/img/industries/e-commerce.png') },
    { name: 'Financial Services', icon: require('../assets/img/industries/financial-services.png') },
    { name: 'Healthcare', icon: require('../assets/img/industries/healthcare.png') },
    { name: 'Education', icon: require('../assets/img/industries/education.png') },
    { name: 'Logistics', icon: require('../assets/img/industries/logistics.png') },
    { name: 'Technology', icon: require('../assets/img/industries/technology.png') },
  ];

  return (
    <section className="py-12 lg:py-16 bg-white">
      <div className="max-w-content mx-auto px-6">
        <h3 className="font-exo font-bold text-ebony-clay text-xl lg:text-2xl tracking-[1.2px] leading-normal text-center mb-8">
          Trusted Across Industries
        </h3>
        <div className="flex flex-wrap justify-center gap-6 lg:gap-12">
          {industries.map((industry) => (
            <span
              key={industry.name}
              className="inline-flex items-center gap-2 font-exo font-semibold text-eerie-black text-sm lg:text-base tracking-[0.8px] leading-normal whitespace-nowrap"
            >
              <img
                src={industry.icon}
                alt=""
                aria-hidden="true"
                className="w-5 h-5 lg:w-6 lg:h-6 object-contain shrink-0"
              />
              {industry.name}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
